import { BaseSection, ColumnSection, SectionColumnWidth, SectionType } from '../../../types';
import { ComponentFactory } from '../component';
import { SectionFactory, SectionOptions } from './base';

export type ColumnSectionOptions = {
  columns: Column[];
  options?: SectionOptions;
};

type Column = {
  width: SectionColumnWidth;
  component: ComponentFactory;
};

export class ColumnSectionFactory extends SectionFactory {
  columns: Column[];

  constructor(options: ColumnSectionOptions) {
    super(options.options);
    this.columns = options.columns;
  }

  __build(base: BaseSection): ColumnSection {
    return {
      ...base,
      type: SectionType.column,
      columns: this.columns.map(col => ({
        width: col.width,
        component: col.component._build(),
      })),
    };
  }
}
